export default __webpack_public_path__ + "static/media/spooky_hill_m1.4f533f68.png";